import React, { useId, useState } from 'react'
import { ConfirmDialog } from '../../../../shared/sso-workspace/confirm-dialog'
import { serverMessage } from '../../../../shared/error/server-message'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { addPackage } from './packages-api'

// Adds a package record (reverse-DNS name, optional display name); the
// package's page opens after.
export const AddPackageDialog = ({ open, onCancel, onAdded }) => {
  const ids = { name: useId(), display: useId() }
  const [name, setName] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()

  const cancel = () => { setError(null); onCancel() }
  const add = async () => {
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      const made = await addPackage({ name: name.trim(), displayName: displayName.trim() })
      setBusy(false)
      setName('')
      setDisplayName('')
      onAdded((made && made.name) || name.trim())
    } catch (err) {
      setBusy(false)
      setError(serverMessage(err, "The package couldn't be added."), err)
    }
  }

  return (
    <ConfirmDialog open={open} title="Add package" body="A package is named in reverse-DNS style, like com.caffeine. Its versions are published by CI with a publish key."
      confirmText="Add" confirmClassName="btn sw-btn-primary" confirmDisabled={!name.trim()} busy={busy} error={error} failure={failure}
      onConfirm={add} onCancel={cancel}>
      <div className="mb-3">
        <label className="sw-label" htmlFor={ids.name}>Package name</label>
        <input id={ids.name} className="form-control" value={name} onChange={e => setName(e.target.value)} placeholder="com.caffeine" />
      </div>
      <div className="mb-3">
        <label className="sw-label" htmlFor={ids.display}>Display name</label>
        <input id={ids.display} className="form-control" value={displayName} onChange={e => setDisplayName(e.target.value)} />
      </div>
    </ConfirmDialog>
  )
}
